<mat-paginator
  [showFirstLastButtons]="false"
  [pageSizeOptions]="itemsPerPageOptions"
  [length]="table.totalItems$ | async"
  (page)="page($event)"
></mat-paginator>
